import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import PromosList from './PromosList'

export default function Promos() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/promos" component={PromosList} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}